export const partDescriptions = {
  self: `Your core Self that embodies the 8 C's:

• Calm - A grounded presence that brings peace to your internal system
• Curious - Open and interested in understanding all parts without judgment
• Compassionate - Holding unconditional love and acceptance for all parts
• Clear - Maintaining perspective and wisdom in your inner work
• Connected - In tune with your parts and their needs
• Creative - Finding new ways to heal and grow
• Confident - Trust in your ability to lead your internal family
• Courageous - Willing to face and work with challenging parts

This is your true essence, the one who can lead your internal family system with wisdom and compassion.`,

  protector: `A guardian part that works hard to keep your system safe and functioning. Protectors often:

• Shield vulnerable parts from potential harm
• Create strategies to avoid emotional pain
• Maintain control through various behaviors
• Stay vigilant for signs of danger
• Enforce boundaries with others
• Manage relationships carefully
• Hold skepticism about change
• Resist vulnerability

This part deserves appreciation for its dedication to your safety and survival.`,

  manager: `A proactive part that maintains order and stability in your life. Managers typically:

• Plan and organize to prevent problems
• Set high standards for performance
• Focus on productivity and achievement
• Maintain routines and structure
• Monitor potential risks
• Handle responsibilities
• Ensure competence
• Keep emotions in check

This part helps you navigate daily life and meet your obligations.`,

  rescuer: `A reactive part that responds quickly to distress in your system. Rescuers often:

• Jump into action when triggered
• Use various coping mechanisms
• Seek immediate relief from pain
• Protect through impulsive responses
• Take over in crisis situations
• Provide temporary comfort
• React strongly to threats
• Guard against overwhelm

This part works hard to help you survive intense emotions and experiences.`,

  exile: `A young, vulnerable part holding pain from the past. Exiles typically:

• Carry unprocessed trauma or grief
• Hold core beliefs about unworthiness
• Feel intense emotions
• Need attention and care
• Seek understanding and validation
• Want to be seen and heard
• Hope for healing and acceptance
• Long for safety and connection

This part needs gentle attention and compassion to heal old wounds.`
};

export const getDefaultDescription = (type: keyof typeof partDescriptions) => {
  return partDescriptions[type] || 'A part of your internal family system.';
};